import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]

import {
    getNormalIncomePerDay,
    missedIncomeForRegulationPerDay,
    payoutPerDayForRegulation,
    Regulation,
    useLeaveStore, uwvMaximumDagloon
} from '@/stores/leave'
import { computed } from 'vue'
import { formatMoney } from '@/helpers/formatMoney'
import RowWithInfo from '@/components/RowWithInfo.vue'
import { translate } from '@/helpers/translate'
import DaysChart from '@/components/DaysChart.vue'
import Days from '@/components/Days.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegulationRow',
  props: {
    regulation: null
  },
  setup(__props: any) {

const props = __props as {
    regulation: Regulation
};



const leaveStore = useLeaveStore()
const { t } = translate()

const salaryMom = computed(() => {
    if (!props.regulation.mom) {
        return
    }

    const dailySalary = leaveStore.dailySalary(true)

    if (dailySalary === null) {
        return
    }

    const payoutPerDay = payoutPerDayForRegulation(props.regulation, dailySalary)
    const missedIncomePerDay = missedIncomeForRegulationPerDay(props.regulation, dailySalary)

    return t('payoutNormalAndMissingMom', {
        payoutPerDay: formatMoney(payoutPerDay),
        normalIncomePerDay: formatMoney(dailySalary),
        missedIncomePerDay: formatMoney(missedIncomePerDay),
    })
})

const salarySecondParent = computed(() => {
    if (!props.regulation.secondParent) {
        return
    }

    const dailySalary = leaveStore.dailySalary(false)

    if (dailySalary === null) {
        return
    }

    const payoutPerDay = payoutPerDayForRegulation(props.regulation, dailySalary)
    const missedIncomePerDay = missedIncomeForRegulationPerDay(props.regulation, dailySalary)

    return t('payoutNormalAndMissingPartner', {
        payoutPerDay: formatMoney(payoutPerDay),
        normalIncomePerDay: formatMoney(dailySalary),
        missedIncomePerDay: formatMoney(missedIncomePerDay),
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RowWithInfo, {
    title: _unref(t)(__props.regulation.title)
  }, {
    info: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: _unref(t)(__props.regulation.info)
      }, null, 8, _hoisted_1),
      _createElementVNode("ul", null, [
        _createElementVNode("div", {
          innerHTML: _unref(t)(__props.regulation.infoList, {
                    uwvDailyMax: _unref(formatMoney)(_unref(uwvMaximumDagloon)),
                    seventyPercentOfUwvMax: _unref(formatMoney)(0.7 * _unref(uwvMaximumDagloon)),
                })
        }, null, 8, _hoisted_2),
        (_unref(salaryMom))
          ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_unref(salaryMom)), 1))
          : _createCommentVNode("", true),
        (_unref(salarySecondParent))
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_unref(salarySecondParent)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        innerHTML: _unref(t)(__props.regulation.infoLink, { url: __props.regulation.url })
      }, null, 8, _hoisted_5)
    ]),
    default: _withCtx(() => [
      (__props.regulation.mom)
        ? (_openBlock(), _createElementBlock("td", {
            key: 0,
            class: _normalizeClass({[_ctx.$style.days]: true, [_ctx.$style.maxed]: _unref(leaveStore).daysUsedByRegulation(__props.regulation.id, true) === __props.regulation.daysOff(_unref(leaveStore).personal.workDaysMom.length * 8) })
          }, [
            _createVNode(Days, {
              value: _unref(leaveStore).daysUsedByRegulation(__props.regulation.id, true)
            }, null, 8, ["value"]),
            _createTextVNode(" / "),
            _createVNode(Days, {
              value: __props.regulation.daysOff(_unref(leaveStore).personal.workDaysMom.length * 8)
            }, null, 8, ["value"])
          ], 2))
        : _createCommentVNode("", true),
      (!__props.regulation.mom)
        ? (_openBlock(), _createElementBlock("td", {
            key: 1,
            class: _normalizeClass(_ctx.$style.na)
          }, "N/A", 2))
        : _createCommentVNode("", true),
      (__props.regulation.secondParent)
        ? (_openBlock(), _createElementBlock("td", {
            key: 2,
            class: _normalizeClass({[_ctx.$style.days]: true, [_ctx.$style.maxed]: _unref(leaveStore).daysUsedByRegulation(__props.regulation.id, false) === __props.regulation.daysOff(_unref(leaveStore).personal.workDaysPartner.length * 8) })
          }, [
            _createVNode(Days, {
              value: _unref(leaveStore).daysUsedByRegulation(__props.regulation.id, false)
            }, null, 8, ["value"]),
            _createTextVNode(" / "),
            _createVNode(Days, {
              value: __props.regulation.daysOff(_unref(leaveStore).personal.workDaysPartner.length * 8)
            }, null, 8, ["value"])
          ], 2))
        : _createCommentVNode("", true),
      (!__props.regulation.secondParent)
        ? (_openBlock(), _createElementBlock("td", {
            key: 3,
            class: _normalizeClass(_ctx.$style.na)
          }, "N/A", 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})